export { InlineMessage } from './inline-message';
export type { TInlineMessageProps } from './inline-message';
export { InlineMessageType } from './inline-message.types';
